import SingleFamilyContractDetails from './SingleFamilyContractDetails';

const SingleFamilyContract = ({ isRequired = false, isActive = false, details = {} } = {}) => ({
  isRequired: Boolean(isRequired),
  isActive: Boolean(isActive),
  details: SingleFamilyContractDetails(details),
});

export default SingleFamilyContract;

export type SingleFamilyContractProps = ReturnType<typeof SingleFamilyContract>;
